var map = {
	"./ai/logoPage.png": 1042,
	"./computernaya-gramotnost/logoPage.png": 1043,
	"./ege-informatika/logoPage.png": 1044,
	"./frontend/logoPage.png": 1045,
	"./game-design/logoPage.png": 1046,
	"./graphic-design-pro/logoPage.png": 1047,
	"./graphic-design/logoPage.png": 1048,
	"./intensive/logoPage.png": 1049,
	"./osnovy-programmirovaniya/logoPage.png": 1050,
	"./predprinimatelstvo/logoPage.png": 1051,
	"./python/logoPage.png": 1052,
	"./scratch/logoPage.png": 1053,
	"./unity/logoPage.png": 1054,
	"./videoblogging/logoPage.png": 1055,
	"./web-razrabotka/logoPage.png": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1680;